import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const squarespace = defineConnector({
  identifier: "squarespace",
  name: "Squarespace",
  tagLine: "Website and commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.squarespace\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Squarespace, go to **Settings › Advanced › Developer API Keys** and generate a new key. Requires a Commerce Advanced plan. See the [API docs](https://developers.squarespace.com/) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.squarespace.com/1.0/authorization/website",
  },
});
